import React from 'react';

import cs from 'classnames';

import {ViewModeTitle} from 'app/general/detailpage/ViewModeTitle';
import {
  ActionMenuItemType,
  ActionsButton,
} from 'app/general/widgets/ActionsButton';
import {gt} from 'app/utils/i18n';

type Props = {
  onToggleReorderMode: () => void;
  title?: string;
  numCollapsedSteps?: number;
  numSteps?: number;
  toggleAllStepsCollapse?: (arg0: boolean) => void;
};

export function ReorderStepsModeTitle({
  onToggleReorderMode,
  title,
  numSteps,
  numCollapsedSteps,
  toggleAllStepsCollapse,
}: Props) {
  const actions: Array<ActionMenuItemType> = [
    {
      text: gt('Move Steps'),
      icon: 'fa fa-fw fa-sort',
      key: 'move-steps',
      disabled: false,
      callback: () => onToggleReorderMode(),
    },
  ];

  if (
    toggleAllStepsCollapse != null &&
    numCollapsedSteps != null &&
    numSteps != null
  ) {
    if (numCollapsedSteps > 0) {
      actions.push({
        text: gt('Expand All'),
        icon: 'fa fa-chevron-down',
        key: 'expand-all',
        callback: () => toggleAllStepsCollapse(false),
      });
    }
    if (numCollapsedSteps < numSteps) {
      actions.push({
        text: gt('Collapse All'),
        icon: 'fa fa-chevron-up',
        key: 'collapse-all',
        callback: () => toggleAllStepsCollapse(true),
      });
    }
  }

  return (
    <ViewModeTitle
      title={title || gt('Steps List')}
      paddingRightClass="pr-0"
      actionsBox={
        <ActionsButton actions={actions}>
          {({className, ...buttonProps}) => (
            <button
              {...buttonProps}
              className={cs(className, 'btn btn-link text-muted')}
            >
              {gt('More')} <i className="fa fa-chevron-down ml-1"></i>
            </button>
          )}
        </ActionsButton>
      }
    />
  );
}
